<context-menu [useBootstrap4]="true">
    <ng-template contextMenuItem (execute)="wordClicked($event)">
        <p>context menu</p>
    </ng-template> 
</context-menu> 